import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/SellerMonthlyExpenses.css';

const SellerMonthlyExpenses = () => {
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    const fetchMonthlyExpenses = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        
        if (!token) {
          setError('No se encontró token de autenticación');
          setLoading(false);
          return;
        }

        const response = await axios.get('/api/seller-monthly-expenses', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        setExpenses(response.data);
        
        // Calcular el total de gastos
        const total = response.data.reduce((sum, expense) => sum + parseFloat(expense.amount), 0);
        setTotalAmount(total);
        
        setLoading(false);
      } catch (error) {
        console.error('Error al obtener gastos mensuales:', error);
        setError('No se pudieron cargar los gastos mensuales');
        setLoading(false);
      }
    };

    fetchMonthlyExpenses();
  }, []);

  // Función para formatear la fecha sin problemas de zona horaria
  const formatDate = (dateString) => {
    try {
      if (!dateString) return 'Fecha no disponible';
      
      // Si la fecha ya viene en formato YYYY-MM-DD o con formato ISO
      if (typeof dateString === 'string') {
        // Extraer solo la parte de la fecha (antes de la T si existe)
        const datePart = dateString.includes('T') ? dateString.split('T')[0] : dateString;
        
        // Convertir formato de fecha YYYY-MM-DD a DD/MM/YYYY
        const parts = datePart.split('-');
        if (parts.length === 3) {
          return `${parts[2]}/${parts[1]}/${parts[0]}`; // DD/MM/YYYY
        }
        
        // Si no se pudo dividir por '-', devolver la fecha original
        return datePart;
      }
      
      // Si es un objeto Date o un timestamp, extraer los componentes manualmente
      // para evitar problemas de zona horaria
      const dateObj = new Date(dateString);
      if (isNaN(dateObj.getTime())) return 'Fecha inválida';
      
      // Obtener año, mes y día en UTC para evitar ajustes de zona horaria
      const day = String(dateObj.getUTCDate()).padStart(2, '0');
      const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
      const year = dateObj.getUTCFullYear();
      
      return `${day}/${month}/${year}`;
    } catch (error) {
      console.error('Error al formatear fecha:', error);
      return dateString || 'Fecha no disponible';
    }
  };

  // Obtener el nombre del mes actual
  const getCurrentMonthName = () => {
    const months = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    const currentMonth = new Date().getMonth();
    return months[currentMonth];
  };

  return (
    <div className="seller-monthly-expenses">
      <h2>Gastos Mensuales - {getCurrentMonthName()}</h2>
      
      {loading ? (
        <div className="loading-message">Cargando gastos mensuales...</div>
      ) : error ? (
        <div className="error-message">{error}</div>
      ) : expenses.length === 0 ? (
        <div className="no-data-message">No hay gastos registrados en el mes actual</div>
      ) : (
        <>
          <div className="expenses-summary">
            <div className="summary-item">
              <span className="summary-label">Total de Gastos:</span>
              <span className="summary-value">${totalAmount.toFixed(2)}</span>
            </div>
            <div className="summary-item">
              <span className="summary-label">Cantidad de Registros:</span>
              <span className="summary-value">{expenses.length}</span>
            </div>
          </div>
          
          <div className="expenses-table-container">
            <table className="expenses-table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Descripción</th>
                  <th>Categoría</th>
                  <th>Monto</th>
                </tr>
              </thead>
              <tbody>
                {expenses.map((expense) => (
                  <tr key={expense.id}>
                    <td>{formatDate(expense.gasto_fecha)}</td>
                    <td>{expense.description || 'Sin descripción'}</td>
                    <td>{expense.typeexpenses?.name || 'No especificado'}</td>
                    <td className="amount">${parseFloat(expense.amount).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default SellerMonthlyExpenses;
